import { useCloseOrFallback } from '../../hooks';
import styles from './PageHeader.module.css';

interface PageHeaderProps {
  title?: string;
  showBack?: boolean;
  onBack?: () => void;
  rightActions?: React.ReactNode;
}

/**
 * Page header component with back navigation and optional title.
 */
export function PageHeader({ title, showBack = true, onBack, rightActions }: PageHeaderProps) {
  // Default back never dead-ends: on a deeplink (no in-app history to pop) it
  // lands on home instead of doing nothing. Callers passing onBack keep control.
  const goBack = useCloseOrFallback('/');

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      goBack();
    }
  };

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.left}>
          {showBack && (
            <button className={styles.backButton} onClick={handleBack} aria-label="Torna indietro">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M19 12H5" />
                <path d="M12 19l-7-7 7-7" />
              </svg>
            </button>
          )}
          {title && <h1 className={styles.title}>{title}</h1>}
        </div>

        {rightActions && <div className={styles.rightActions}>{rightActions}</div>}
      </div>
    </header>
  );
}
